import React, { Component, useEffect, useState } from 'react';
import crmservices from '../../wsclient/'
import OrderMainPageView from './OrderMainPageView';
import { callCartItemListeners, getAppCfg, getContacts, getCurrency, initOptionHeader, setMyOrderListener } from '../../utils/common';
import { setOrderCache, order_key, getOrderCache, clearOrder, addToCart } from '../../utils/order_cache';
import t from '../../utils/translateUtil';
import MyOrderDetailController from './MyOrderDetailController';
import PromotionDetail from './PromotionDetail';
import { dataUtil, preferences_type } from '../../wsclient/crmservices/dataUtil';
import AddCard from '../order-cards/AddCard';
import OrderMerchantsController from './OrderMerchantsController';
import OrderStoresController from './OrderStoresController';
import OrderDirectSaleStoresController from './OrderDirectSaleStoresController';
import OrderCatalogues from './OrderCatalogues';
import { domainName, portal_config } from '../../../portal.config';
import { useHistory } from 'react-router-dom';
import { paths } from '../../../portal.router.config';
function OrderMainPageController(props) {
    const history = useHistory();

    const [showLoading, onShowLoading] = useState(false);
    const [showLoadingMyOrders, onShowLoadingMyOrders] = useState(false);
    const [showLoadingOffers, onShowLoadingOffers] = useState(false);
    const [showStores, onShowStores] = useState(false);
    const [showAddresses, onShowAdresses] = useState(false);
    const [showMenuItems, onShowMenuItems] = useState(false);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [delivery_address, setDeliverAddress] = useState(null);
    const [showDetailOrder, setShowDetailOrder] = useState(false);
    const [showDetailPromotion, setShowDetailPromotion] = useState(false);
    const [showAddCardForm, setShowAddCardForm] = useState(false);
    const [order, setOrder] = useState(null);
    const [stores, setStores] = useState([]);
    const [my_orders, setMyOrders] = useState({
        paging: {},
        content: []
    });
    const [promotions, setPromotions] = useState([]);
    const [my_cards, setMyCards] = useState({
        paging: {},
        content: []
    });

    const [message, setMessage] = useState({});
    const [refreshMyOrder, setRefreshMyOrder] = useState(false);
    const [pick_up_store, setPickupStore] = useState(null);
    const [time, setTime] = useState(0);
    const [showSelectMerchant, onShowSelectMerchant] = useState(false);
    const [reOrder, setReOrder] = useState(false);
    const [showOrderCatalogues, onShowOrderCatalogues] = useState(false);
    const [catalogActive, setCatalogActive] = useState([]);
    const [showSelectStore, onShowSelectStore] = useState(false);
    const [showSelectDirectSaleStore, onShowSelectDirectSaleStore] = useState(false);
    const [promotion, setPromotion] = useState(null);
    const [html_add_card_content, setHtmlAddCardContent] = useState(null);
    const [confirm, setConfirm] = useState({});
    const [supp_method, setSuppMethod] = useState(undefined);
    const [isRunning, setGetLocationStatus] = useState('start')
    const [locationCheckTimer, setLocationCheckTimer] = useState(null);
    const [initialRegion, setInitRegion] = useState({
        lat: 35.157322,
        lng: 33.313751
    });
    const [orderToBeReOrder, setOrderToBeReOrder] = useState(null);
    const [addresses, setAddresses] = useState([]);
    var app_config = getAppCfg();
    const currency = getCurrency();
    const isShowOffer = app_config && app_config.features && app_config.features.rewards ? app_config.features.rewards : false;
    const ordering_model = app_config.features && app_config.features.business_network_details ? app_config.features.business_network_details.ordering_model : null;
    let contact = getContacts();

    useEffect(() => {
        init()
        return () => setMyOrderListener(undefined);
    }, [])

    useEffect(() => {
        let isDirectSale = app_config.features && app_config.features.ordering_details ? app_config.features.ordering_details.ordering_direct_sale : false;
        if (isRunning == 'start') {
            let locationCheckTimer = setInterval(() => getLocation(), 500)
            setLocationCheckTimer(locationCheckTimer)
        }
        else {
            stopCheckingLocation();
        }
        return () => clearInterval(locationCheckTimer);
    }, [isRunning])

    const getLocation = async () => {
        //console.log('getLocation==== ')
        setCurrentLocation(initialRegion);
        await navigator.geolocation.getCurrentPosition((location) => {
            var currentLocation = {
                lat: location.coords.latitude,
                lon: location.coords.longitude,
            }
            //hardcode
            // var currentLocation = {
            //     lat: 35.157322,
            //     lng: 33.313751
            // }
            // var currentLocation = {
            //     lat: 38.00934, 
            //     lng: 23.77984,
            // }
            console.log("AAAAA location:", location);
            setCurrentLocation(currentLocation);
            stopCheckingLocation();
        }, (err) => {
            console.log('getLocation err', err)
            onShowLoading(false);;
            stopCheckingLocation();

        }, {
            timeout: 60000,
            enableHighAccuracy: false
        });
    }

    const getStores = async (params) => {
        let stores = [];
        try {
            console.log("AAAAAAAAAAAA params:", params);
            var body = {
                supply_method: "DIRECT_SALE"
            }
            if (params && params.lat && params.lng)
                body.lat_lot = params.lat + ":" + params.lng;
            var result = await crmservices.orders.orderFulfillment(body);
            console.log("OrderStoresController result:", result);
            onShowLoading(false)
            if (result.code == 'OK') {
                stores = result.data && result.data.fulfilled_by ? result.data.fulfilled_by : [];
            }
        } catch (error) {
            console.log("load merchants exception:", error);
        }
        return stores;
    }

    const stopCheckingLocation = () => {
        console.log('stopCheckingLocation')
        setGetLocationStatus('stop');
        if (locationCheckTimer) {
            clearInterval(locationCheckTimer);
        }
    }
    const init = async () => {
        onLoadPromotions()
        await onLoadFavouriteShop();
        await getDeliveryAddress();
        setMyOrderListener(loadMyOrders)
        loadMyOrders();
    }

    const onLoadPromotions = async () => {
        onShowLoadingOffers(true);
        try {
            var result = await crmservices.rewards.getPromotions();
            if (result.code == 'OK') {
                //console.log('Promotions result====', result)
                setPromotions(result.data.content);
            }
        } catch (error) {
            console.log('load favourite shop exception:', error);
        }
        onShowLoadingOffers(false);
    }
    const onLoadFavouriteShop = async () => {
        try {
            var result = await crmservices.contacts.getContactPreferences();
            //console.log("AAAAAAAAAAAA result:", result);
            if (result.code == 'OK') {
                setOrderCache(order_key.order_favourite_shop, result.data && result.data.organisations ? result.data.organisations : []);
            }
        } catch (error) {
            console.log('load favourite shop exception:', error);
        }
    }
    const getDeliveryAddress = async () => {
        try {
            var result = await crmservices.contacts.getAddresses();
            console.log("getDeliveryAddress result:", result);
            if (result.code === 'OK') {
                var addresses = result.data && result.data.content ? result.data.content : [];
                if (addresses.length > 0) {
                    var address = addresses.filter(add => {
                        if (add.is_primary) {
                            return add;
                        }
                    })
                    if (address.length > 0) {
                        setOrderCache(order_key.delivery_address, address[0]);
                    }
                }
            }
        } catch (error) {
            console.log("load address error:", error);
        }
    }

    const loadMyOrders = async () => {
        onShowLoadingMyOrders(true);
        try {
            var result = await crmservices.orders.getMyOrders();
            //  console.log('loadMyOrders=========', result)
            if (result.code === 'OK') {
                setMyOrders(result.data);
            }
        } catch (error) {
            console.log("load my order exception:", error);
        }
        onShowLoadingMyOrders(false);
    }

    const handleShowRightContent = (target) => {

        callCartItemListeners();

        if (target === 'showMenuItems') {
            onShowMenuItems(!showMenuItems);
            if (catalogActive && catalogActive.length && catalogActive.length > 1) {
                if(!reOrder) onShowOrderCatalogues(true);
                else onShowOrderCatalogues(false);
            }
        }
        else if (target === 'showAddresses') {
            onShowAdresses(!showAddresses)
        }
        else if (target === 'showStores') {
            onShowStores(!showStores);
        }
    }
    const clearCart = (order_type) => {
        var carts = getOrderCache(order_key.cart);
        var isClear = false;
        if (carts && carts.length > 0) {
            if (getOrderCache(order_key.order_status, true) === 'DONE') {
                isClear = true;
            } else {
                //console.log("aaaaaaaaaaaaaaaa", getOrderCache(order_key.order_type, true));
                if (order_type != getOrderCache(order_key.order_type, true)) {
                    isClear = true;
                }
            }
        }
        if (isClear) {
            clearOrder();
        }
        callCartItemListeners();
    }
    const onInitOrderDelivery = async (re_order) => {
        if(portal_config && portal_config[domainName].isOrderWithFilterMerchant){
            await onInitOrderDeliveryWithFilterMerchants(re_order)
        } else {
            setReOrder(re_order);
            clearCart('DELIVERY');
            setOrderCache(order_key.order_status, 'NEW', true)
            onShowLoading(true);
            var deliveryAddress = getOrderCache(order_key.delivery_address)
            if (deliveryAddress) {
                try {
                    var isMarketPlace = ordering_model && ordering_model == "MARKETPLACE";
                    var favourite_shop = dataUtil.filterContactPreferencesByType(getOrderCache(order_key.order_favourite_shop), preferences_type.order);
                    var isFavourite_shop = favourite_shop && favourite_shop.id;
                    // console.log("ÂXASDASDASDADAD favourite_shop:",favourite_shop);
                    console.log("orderToBeReOrder:", orderToBeReOrder);
                    if (isFavourite_shop || !isMarketPlace) {
                        var payload = {
                            supply_method: "DELIVERY",
                        }
                        if (deliveryAddress.id)
                            payload.address_id = deliveryAddress.id// address select
                        else {
                            payload.lat_lot = deliveryAddress.lat + ":" + deliveryAddress.lon //current location
                            payload.postal_code = deliveryAddress.postal_code;
                        }
                        if (isFavourite_shop) {
                            payload.requested_organisation_id = favourite_shop.id;
                        }
                        var result = await crmservices.orders.orderFulfillment(payload);
                        //console.log("result:", result);
                        if (result.code == 'OK' && result.data && result.data.fulfilled_by && result.data.fulfilled_by.length > 0) {
                            if (portal_config.isLocationVN && result.data.fulfilled_by[0].payment_method_types) {
                                result.data.fulfilled_by[0].payment_method_types.push('VNPAY')
                            }
                            setOrderCache(order_key.order_type, "DELIVERY", true)
                            setOrderCache(order_key.delivery_fulfilled_by, result.data.fulfilled_by[0]);
                            await getCatalogs("DELIVERY", result.data.fulfilled_by[0].id, re_order)
                            //setState({ showMenuItems: true });
                        } else if (result.code == 'CAN_NOT_FULFILL_ORDER_EXCEPTION') {
                            showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
                        } else {
                            if (isFavourite_shop) {
                                delete payload.requested_organisation_id;
                                //console.log("AAAAAAAAAAAA payload:",payload);
                                var orderFulfillmentResult = await crmservices.orders.orderFulfillment(payload);
                                //console.log("AAAAAAAAAAAA orderFulfillmentResult:",orderFulfillmentResult);
                                if (orderFulfillmentResult.code == 'OK' && orderFulfillmentResult.data && orderFulfillmentResult.data.fulfilled_by && orderFulfillmentResult.data.fulfilled_by.length > 0) {
                                    if (portal_config.isLocationVN && orderFulfillmentResult.data.fulfilled_by[0].payment_method_types) {
                                        orderFulfillmentResult.data.fulfilled_by[0].payment_method_types.push('VNPAY')
                                    }
                                    setOrderCache(order_key.order_type, "DELIVERY", true)
                                    setOrderCache(order_key.delivery_fulfilled_by, orderFulfillmentResult.data.fulfilled_by[0]);
    
                                    //console.log(' order==',getOrderCache(order_key.delivery_fulfilled_by))
                                    await getCatalogs("DELIVERY", orderFulfillmentResult.data.fulfilled_by[0].id)
                                    //setState({ showMenuItems: true });
                                } else if (orderFulfillmentResult.code == 'CAN_NOT_FULFILL_ORDER_EXCEPTION') {
                                    showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
                                } else {
                                    showMessage(true, t('DELIVERY_VALIDATION_TIME'));
                                }
                            } else {
                                showMessage(true, t('DELIVERY_VALIDATION_TIME'));
                            }
                        }
                    }
                    else {
                        onShowSelectMerchant(true)
                    }
                } catch (error) {
                    console.log('create order exception:', error)
                    showMessage(true, t('EXCEPTION_PROCESS'));
                    onShowLoading(false);
                }
                onShowLoading(false);
            } else {
                showMessage(true, t('ORDER_SELECT_ADDRESS'));
            }
        }
    }
    const onInitReOrderDelivery = async (re_order) => {
        onShowLoading(true);
        setReOrder(re_order);
        var deliveryAddress = getOrderCache(order_key.delivery_address)
        if (deliveryAddress) {
            try {
                var isMarketPlace = ordering_model && ordering_model == "MARKETPLACE";
                // console.log("ÂXASDASDASDADAD favourite_shop:",favourite_shop);
                console.log("orderToBeReOrder:", orderToBeReOrder);
                if (!isMarketPlace) {
                    var payload = {
                        supply_method: "DELIVERY",
                    }
                    if (deliveryAddress.id)
                        payload.address_id = deliveryAddress.id// address select
                    else {
                        payload.lat_lot = deliveryAddress.lat + ":" + deliveryAddress.lon //current location
                        payload.postal_code = deliveryAddress.postal_code;
                    }
                    var result = await crmservices.orders.orderFulfillment(payload);
                    //console.log("result:", result);
                    if (result.code == 'OK' && result.data && result.data.fulfilled_by && result.data.fulfilled_by.length > 0) {
                        if (portal_config.isLocationVN && result.data.fulfilled_by[0].payment_method_types) {
                            result.data.fulfilled_by[0].payment_method_types.push('VNPAY')
                        }
                        setOrderCache(order_key.order_type, "DELIVERY", true)
                        setOrderCache(order_key.delivery_fulfilled_by, result.data.fulfilled_by[0]);
                        await getCatalogs("DELIVERY", result.data.fulfilled_by[0].id, re_order)
                        //setState({ showMenuItems: true });
                    } else if (result.code == 'CAN_NOT_FULFILL_ORDER_EXCEPTION') {
                        showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
                    } else {
                        showMessage(true, t('DELIVERY_VALIDATION_LOCATION'));
                    }
                }
                else {
                    setOrderCache(order_key.order_type, "DELIVERY", true);
                    await addItemsToCart(orderToBeReOrder.order_items);
                    onShowSelectMerchant(true);
                }
            } catch (error) {
                console.log('create order exception:', error)
                showMessage(true, t('EXCEPTION_PROCESS'));
                onShowLoading(false);
            }
            onShowLoading(false);
        } else {
            showMessage(true, t('ORDER_SELECT_ADDRESS'));
        }
    }
    const onGoBackAfterSetCurrentAddress = async (address) => {
        //console.log(' onGoBackAfterSetCurrentAddress address==', address);
        handleShowRightContent("showAddresses")
        if (address) {
            await setOrderCache(order_key.delivery_address, address);
            if(reOrder){
                onInitReOrderDelivery(true);
            }else{
                onInitOrderDelivery();
            }
        } else {
            showMessage(true, t('ORDER_SELECT_ADDRESS'));
        }
    }
    const onInitOrderPickUp = async (supply_method, key, re_order) => {
        setReOrder(re_order);
        setSuppMethod(supply_method);
        if (key === 'open_menu') {
            clearCart("PICK_UP");
            setOrderCache(order_key.order_status, 'NEW', true)
            var pickupStoreAddress = getOrderCache(order_key.pick_up_store);
            if (pickupStoreAddress && pickupStoreAddress.id) {
                onShowLoading(true);
                try {
                    setOrderCache(order_key.order_type, "PICK_UP", true)
                    setOrderCache(order_key.delivery_fulfilled_by, [])
                    await getCatalogs('PICK_UP', pickupStoreAddress.id, reOrder)
                    //setState({ showMenuItems: true });
                } catch (error) {
                    console.log('create order exception:', error);
                    showMessage(true, t('EXCEPTION_PROCESS'));
                }
                onShowLoading(false);
            } else {
                showMessage(true, t('ORDER_SELECT_STORE'));
            }
        }
        else {
            setOrderCache(order_key.order_status, 'NEW', true)
            onShowSelectStore(true)
        }

    }

    // const onInitOrderDirectSale = async (supply_method, key) => {
    //     setReOrder(false);
    //     setSuppMethod(supply_method);
    //     if (key === 'open_menu') {
    //         clearCart("DIRECT_SALE");
    //         setOrderCache(order_key.order_status, 'NEW', true)
    //         var pickupStoreAddress = getOrderCache(order_key.pick_up_store);
    //         if (pickupStoreAddress && pickupStoreAddress.id) {
    //             onShowLoading(true);
    //             try {
    //                 setOrderCache(order_key.order_type, "DIRECT_SALE", true)
    //                 setOrderCache(order_key.delivery_fulfilled_by, [])
    //                 await getCatalogs('DIRECT_SALE', pickupStoreAddress.id)
    //                 //setState({ showMenuItems: true });
    //             } catch (error) {
    //                 console.log('create order exception:', error);
    //                 showMessage(true, t('EXCEPTION_PROCESS'));
    //             }
    //             onShowLoading(false);
    //         } else {
    //             showMessage(true, t('ORDER_SELECT_STORE'));
    //         }
    //     }
    //     else {
    //         onShowLoading(true);
    //         let stores = await getStores(currentLocation);
    //         if (stores.length == 0) {
    //             showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
    //         } else if (stores.length == 1) {
    //             setOrderCache(order_key.order_type, "DIRECT_SALE", true)
    //             setOrderCache(order_key.delivery_fulfilled_by, [])
    //             setOrderCache(order_key.pick_up_store,stores[0]);
    //             await getCatalogs('DIRECT_SALE', stores[0].id);
    //         } else {
    //             onShowSelectDirectSaleStore(true);
    //             await setStores(stores);
    //         }
    //         onShowLoading(false);
    //     }

    // }

    const onInitOrderDirectSale = async (supply_method, key) => { 
        onShowLoading(true);
        try{
            let hasPhone = true;
            let hasAddress = true;
            let checkCard = true;
            //global ayna ott
            if(domainName === 'ayna' && !document._portalConfig.usePaymentLocal){
                checkCard = await onCheckCard();
            }
            if(!checkCard) {
                showMessage(true, t('SPECIFY_CARD'));
                return false;
            }
            if(domainName === 'ayna' && document._portalConfig.usePaymentLocal){
                hasPhone = await onLoadPhone();
                hasAddress = await onLoadAddresses();
            }
            if (hasPhone && hasAddress) {
                let appConfig = getAppCfg();
                let paymentMethodTypes = appConfig && appConfig.allowed_payment_methods ? appConfig.allowed_payment_methods : [];
                if(paymentMethodTypes && paymentMethodTypes.length > 0){
                    let newPaymentMethodTypes = [];
                    paymentMethodTypes.forEach(item => {
                        newPaymentMethodTypes.push(item.payment_method_type);
                    });
                    paymentMethodTypes = newPaymentMethodTypes;
                }
    
                setReOrder(false);
                setSuppMethod(supply_method);
                setOrderCache(order_key.pick_up_store, {
                    payment_method_types: domainName === 'ayna' ? ['CARD', 'WALLET'] :  paymentMethodTypes,
                });
                if (key === 'open_menu') {
                    clearCart("DIRECT_SALE");
                    setOrderCache(order_key.order_status, 'NEW', true)
                    setOrderCache(order_key.order_type, "DIRECT_SALE", true)
                    setOrderCache(order_key.delivery_fulfilled_by, [])
                    await getCatalogs('DIRECT_SALE', null)
                }else{
                    setOrderCache(order_key.order_status, 'NEW', true)
                    setOrderCache(order_key.order_type, "DIRECT_SALE", true)
                    setOrderCache(order_key.delivery_fulfilled_by, [])
                    await getCatalogs('DIRECT_SALE', null);
                }
            }else{
                showMessage(true, t('CONTACT_PHONE_OR_ADDRESS_NOT_FOUND'));
            }
        }catch(error){
            console.log('onInitOrderDirectSale exception:', error);
        }
        onShowLoading(false);
    }

    const onLoadPhone = async () => {
        let hasPhone = false;
        try{
            var phoneResult = await crmservices.contacts.getPhones();
            console.log('MyProfile onLoadProfile phoneResult=', phoneResult)
            if (phoneResult.code === 'OK') {
                var content = phoneResult.data.content;
                if (content && content.length > 0) {
                    var phone = content.filter(p => p.is_primary);
                    if (phone && phone.length > 0) {
                        hasPhone = true;
                    }
                } else {
                    hasPhone = false;
                }
            }
        }catch(ex){
            console.log("onLoadPhone exception===", ex);
        }
        return hasPhone;
    }

    const onLoadAddresses = async () => {
        let hasAddress = false;
        try {
            var result = await crmservices.contacts.getAddresses();
            console.log('onLoadAddresses result==', result)
            if (result.code === 'OK') {
                if(result.data && result.data.content && result.data.content.length > 0){
                    hasAddress = true;
                }
            }
        } catch (error) {
            console.log('load addresses exception:', error);
        }
        return hasAddress;
    }

    const getCatalogs = async (order_type, fulfilled_by, isReOrder) => {
        await setOrderCache(order_key.catalog_selected, null)
        try {
            const app_config = getAppCfg();
            let order_catalogs_appcfg = app_config && app_config.features && app_config.features.ordering_details && app_config.features.ordering_details.order_catalogs ? app_config.features.ordering_details.order_catalogs : [];
            if(order_catalogs_appcfg.length === 0){
                var body = {
                    supply_method: order_type,
                    fulfilled_by: fulfilled_by,
                    ordering_time: Math.floor(new Date().getTime() / 1000),
                }
                var result = await crmservices.orders.getOrderCatalogs(body);
                //console.log('getOrderCatalogs result:', result);
                if (result.code == 'OK' && result.data.content && result.data.content.length > 0) {
                    order_catalogs_appcfg = result.data.content.filter(catalog => {
                        return catalog.life_cycle_state == "ACTIVE"
                    });
                }
            }
            if(isReOrder){
                if(order_catalogs_appcfg.length > 0){
                    await setOrderCache(order_key.catalog_selected, order_catalogs_appcfg[0])
                    onShowMenuItems(true);
                    setReOrder(true);
                    onShowOrderCatalogues(false);
                }
            }else{
                if(order_catalogs_appcfg.length === 1){
                    await setOrderCache(order_key.catalog_selected, order_catalogs_appcfg[0])
                    setCatalogActive([]);
                    onShowMenuItems(true);
                }
                else if(order_catalogs_appcfg.length > 1){
                    setCatalogActive(order_catalogs_appcfg);
                    onShowOrderCatalogues(true);
                } else {
                    onShowMenuItems(true);
                }
            }
        } catch (error) {
            console.log("get all categories exception:", error);

        }
    }

    const onSelectCatalog = async (catalog) => {
        onShowOrderCatalogues(false);
        await setOrderCache(order_key.catalog_selected, catalog);
        onShowMenuItems(true);
    }
    const onShowDetailOrder = async (item) => {
        onShowLoading(true)
        try {
            var result = await crmservices.orders.getOrder(item.id);

            if (result.code === 'OK') {
                item = { ...item, ...result.data };
                console.log('onShowDetail item= ', item)
                setOrder(item);
                onShowLoading(false);
                setShowDetailOrder(true);

            } else {
                showMessage(true, t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            console.log("on get order:", error);
            showMessage(true, t('EXCEPTION_PROCESS'))
        }
    }
    const onShowDetailPromotion = (promotion) => {
        setShowDetailPromotion(true);
        setPromotion(promotion);
    }

    const showMessage = (status, message, onClose) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null,
            onClose: onClose ? onClose : null,
        });
    }
    const showConfirm = (status, message) => {
        onShowLoading(false)
        setConfirm({
            show: status,
            content: message ? message : null
        })
    }
    const onShowAddCardForm = async () => {
        //console.log(' onShowAddCardForm====')
        showConfirm(false);
        setShowAddCardForm(!showAddCardForm);
        onShowLoading(true);
        try {
            var result = await crmservices.contacts.createFormToAddCard();
            // console.log(' onPrepareForm result===', result)
            if (result.code == 'OK') {
                //window.document.write(result.data);
                setHtmlAddCardContent(result.data);
            }
        } catch (error) {
            console.log("on create form to add card exception:", error);
        }
        onShowLoading(false);
    }

    const onCloseSelectMerchant = async (key) => {
        onShowSelectMerchant(false);
        onShowLoading(true);
        //onInitOrderDelivery(true);
        if (key === 'open_menu') {
            try {
                var delivery_fulfilled_by = await getOrderCache(order_key.delivery_fulfilled_by);
                clearCart('DELIVERY');
                setOrderCache(order_key.order_status, 'NEW', true)
                setOrderCache(order_key.order_type, "DELIVERY", true)
                await getCatalogs('DELIVERY', delivery_fulfilled_by.id, reOrder);
                //setState({ showMenuItems: true });
            } catch (error) {
                console.log(" select merchant exception:", error);
            }
        }
        onShowLoading(false);
    }

    const onReorder = async (item) => {
        onShowLoading(true);
        onShowOrderCatalogues(false);
        try {
            var result = await crmservices.orders.getOrder(item.id);
            if (result.code === 'OK') {
                item = { ...item, ...result.data };
                setOrderToBeReOrder(item);
                var app_config = getAppCfg();
                var ordering_model = app_config.features && app_config.features.business_network_details ? app_config.features.business_network_details.ordering_model : null;
                var isMarketPlace = ordering_model && ordering_model == "MARKETPLACE";
                setReOrder(true);
                // debugger;
                if (item.supply_method == 'DELIVERY') {
                    if(isMarketPlace){
                        clearOrder();
                        setOrderCache(order_key.order_status, 'NEW', true);
                        await initDeliveryOrderMarketPlace(item.address,item.fulfilled_by.id,item.order_items);
                    }
                    else {
                        clearOrder();
                        setOrderCache(order_key.order_status, 'NEW', true);
                        onShowLoading(false);
                        onShowAdresses(true);
                    }
                } else if(item.supply_method == 'PICK_UP'){
                    if(isMarketPlace){
                        clearOrder();
                        setOrderCache(order_key.order_status, 'NEW', true);
                        await initPickupOrderMarketPlace(item.fulfilled_by,item.order_items);
                    } else {
                        clearOrder();
                        setOrderCache(order_key.order_status, 'NEW', true);
                        setOrderCache(order_key.order_type, 'PICK_UP', true);
                        setOrderCache(order_key.delivery_fulfilled_by, []);
                        await addItemsToCart(item.order_items);
                        onShowSelectStore(true);
                    }
                }
            }
        }catch (error) {
            console.log("reorder exception:", error);
            showMessage(t('ERROR'), t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }
    
    const addItemsToCart = async (order_items) => {
        for (let index = 0; index < order_items.length; index++) {
            const item = order_items[index];
            if (item.product.name && item.product.name.toLowerCase().includes('delivery')) {
                //do nothing
            } else {
                let productToBeAdded = dataUtil.createItemToReorder(item, true);
                await addToCart(productToBeAdded)
            }
        }
    }

    const onCheckCard = async () => {
        let checkCard = false;
        try{
            var result = await crmservices.contacts.getListPaymentMethods();
            if (result.code == 'OK') {
                var cards = result.data && result.data.content ? result.data.content : [];
                if (cards.length > 0) {
                    var cardPrimary = cards.filter(card => {
                        return card.payment_method_type === 'CARD' && card.is_primary && card.name.toLowerCase() === 'stripe' 
                    });
                    if(cardPrimary && cardPrimary.length > 0){
                        checkCard = true;
                    }
                }
            }
        }catch(ex){
            console.log("onCheckCard exception===", ex);
        }
        return checkCard;
    }
    const onInitOrderDeliveryWithFilterMerchants = async (re_order) => {
        setReOrder(re_order);
        clearCart('DELIVERY');
        setOrderCache(order_key.order_status, 'NEW', true)
        onShowLoading(true);
        var deliveryAddress = getOrderCache(order_key.delivery_address)
        if (deliveryAddress) {
            try {
                var isMarketPlace = ordering_model && ordering_model == "MARKETPLACE";
                var favourite_shop = dataUtil.filterContactPreferencesByType(getOrderCache(order_key.order_favourite_shop), preferences_type.order);
                var isFavourite_shop = favourite_shop && favourite_shop.id;
                // console.log("ÂXASDASDASDADAD favourite_shop:",favourite_shop);
                console.log("orderToBeReOrder:", orderToBeReOrder);
                if (isFavourite_shop || !isMarketPlace) {
                    var payload = {
                        supply_method: "DELIVERY",
                    }
                    if (deliveryAddress.id)
                        payload.address_id = deliveryAddress.id// address select
                    else {
                        payload.lat_lot = deliveryAddress.lat + ":" + deliveryAddress.lon //current location
                        payload.postal_code = deliveryAddress.postal_code;
                    }
                    if (isFavourite_shop) {
                        payload.requested_organisation_id = favourite_shop.id;
                    }
                    var result = await crmservices.orders.orderFulfillment(payload);
                    //console.log("result:", result);
                    if (result.code == 'OK' && result.data && result.data.fulfilled_by && result.data.fulfilled_by.length > 0) {
                        if (portal_config.isLocationVN && result.data.fulfilled_by[0].payment_method_types) {
                            result.data.fulfilled_by[0].payment_method_types.push('VNPAY')
                        }
                        let orgNetworks = await onGetOrgNetwork({});
                        let merchants = dataUtil.compareMerchants(result.data.fulfilled_by, orgNetworks);
                        if(merchants && merchants.length > 0){
                            setOrderCache(order_key.order_type, "DELIVERY", true)
                            setOrderCache(order_key.delivery_fulfilled_by, result.data.fulfilled_by[0]);
                            await getCatalogs("DELIVERY", result.data.fulfilled_by[0].id, re_order)
                        }else{
                            showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
                        }
                        //setState({ showMenuItems: true });
                    } else if (result.code == 'CAN_NOT_FULFILL_ORDER_EXCEPTION') {
                        showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
                    } else {
                        if (isFavourite_shop) {
                            delete payload.requested_organisation_id;
                            //console.log("AAAAAAAAAAAA payload:",payload);
                            var orderFulfillmentResult = await crmservices.orders.orderFulfillment(payload);
                            //console.log("AAAAAAAAAAAA orderFulfillmentResult:",orderFulfillmentResult);
                            if (orderFulfillmentResult.code == 'OK' && orderFulfillmentResult.data && orderFulfillmentResult.data.fulfilled_by && orderFulfillmentResult.data.fulfilled_by.length > 0) {
                                if (portal_config.isLocationVN && orderFulfillmentResult.data.fulfilled_by[0].payment_method_types) {
                                    orderFulfillmentResult.data.fulfilled_by[0].payment_method_types.push('VNPAY')
                                }
                                let orgNetworks = await onGetOrgNetwork({});
                                let merchants = dataUtil.compareMerchants(orderFulfillmentResult.data.fulfilled_by, orgNetworks);
                                if(merchants && merchants.length > 0){
                                    setOrderCache(order_key.order_type, "DELIVERY", true)
                                    setOrderCache(order_key.delivery_fulfilled_by, orderFulfillmentResult.data.fulfilled_by[0]);
                                    await getCatalogs("DELIVERY", orderFulfillmentResult.data.fulfilled_by[0].id)
                                } else {
                                    showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
                                }
                                //setState({ showMenuItems: true });
                            } else if (orderFulfillmentResult.code == 'CAN_NOT_FULFILL_ORDER_EXCEPTION') {
                                showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
                            } else {
                                showMessage(true, t('DELIVERY_VALIDATION_TIME'));
                            }
                        } else {
                            showMessage(true, t('DELIVERY_VALIDATION_TIME'));
                        }
                    }
                }
                else {
                    onShowSelectMerchant(true)
                }
            } catch (error) {
                console.log('create order exception:', error)
                showMessage(true, t('EXCEPTION_PROCESS'));
                onShowLoading(false);
            }
            onShowLoading(false);
        } else {
            showMessage(true, t('ORDER_SELECT_ADDRESS'));
        }
    }

    const onGetOrgNetwork = async (param) => {
        let orgNetworks = [];
        try{
            let result = await crmservices.rewards.getOrgLocations(param);
            console.log("result getOrgLocations ===", result);
            if(result.code === 'OK'){
                if(result.data && result.data.content) orgNetworks = result.data.content;
            }
        }catch(ex){
            console.log("onGetOrgNetwork exception ===", ex);
        }
        return orgNetworks;
    }

    const initDeliveryOrderMarketPlace = async (deliveryAddress, initiateFulfillmentId, orderItems) => {
        onShowAdresses(false);
        if (deliveryAddress) {
            var payload = {
                supply_method: "DELIVERY"
            }
            if (deliveryAddress.id) {
                payload.address_id = deliveryAddress.id;
            } else if (deliveryAddress.lat && deliveryAddress.lon) {
                payload.lat_lot = deliveryAddress.lat + ":" + deliveryAddress.lon;
                payload.postal_code = deliveryAddress.postal_code;
            }
            var result = await crmservices.orders.orderFulfillment(payload);
            if (result.code == 'OK' && result.data && result.data.fulfilled_by && result.data.fulfilled_by.length > 0) {
                let existingFulfillment = result.data.fulfilled_by.filter(f => {
                    return f.id == initiateFulfillmentId;
                })
                if(existingFulfillment && existingFulfillment.length > 0){
                    setOrderCache(order_key.order_type, "DELIVERY", true)
                    setOrderCache(order_key.delivery_fulfilled_by, existingFulfillment[0]);
                    await addToCartItem(orderItems);
                    await getCatalogs('DELIVERY', existingFulfillment[0].id, true);
                }else{
                    showMessage(true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
                }
            } else if (result.code == 'CAN_NOT_FULFILL_ORDER_EXCEPTION') {
                showMessage( true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
            } else {
                showMessage( true, t('DELIVERY_VALIDATION_LOCATION'));
            }
        } else {
            showMessage( true, t('CAN_NOT_GET_CURRENT_LOCATION'));
        }
    }

    const initPickupOrderMarketPlace = async (fulfilled_by,orderItems) => {
        onShowAdresses(false);
        var payload = {
            supply_method: "PICK_UP"
        }
        if (fulfilled_by.address && fulfilled_by.address) {
            if (fulfilled_by.address.lat && fulfilled_by.address.lon) {
                payload.lat_lot = fulfilled_by.address.lat + ":" + fulfilled_by.address.lon;
            }
            if(fulfilled_by.address.postal_code){ 
                payload.postal_code = fulfilled_by.address.postal_code;
            }
        }
        var result = await crmservices.orders.orderFulfillment(payload);
        if (result.code == 'OK' && result.data && result.data.fulfilled_by && result.data.fulfilled_by.length > 0) {
            let existingFulfillment = result.data.fulfilled_by.filter(f => {
                return f.id == fulfilled_by.id;
            })
            if(existingFulfillment && existingFulfillment.length > 0){
                setOrderCache(order_key.order_type, 'PICK_UP', true);
                setOrderCache(order_key.pick_up_store, existingFulfillment[0])
                setOrderCache(order_key.delivery_fulfilled_by, []);
                await addToCartItem(orderItems);
                await getCatalogs('PICK_UP', existingFulfillment[0].id, true);
            }else{
                showMessage( true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
            }
        }else{
            showMessage( true, t('CAN_NOT_FULFILL_ORDER_EXCEPTION'));
        }
    }
    
    const addToCartItem = async (order_items) => {
        console.log("order_items:", order_items);
        for (let index = 0; index < order_items.length; index++) {
            const item = order_items[index];
            if (item.product.name && item.product.name.toLowerCase().includes('delivery')) {
                //do nothing
            } else {
                let productToBeAdded = dataUtil.createItemToReorder(item);
                // await cache.addToCart(productToBeAdded)
                await addToCart(productToBeAdded)
            }
        }
    }

    const onLookUpLocation = async (order_type) => {
        let checkLocation = true;
        try{
            if(currentLocation){
                let result = await crmservices.contacts.findAddress({ latlng: currentLocation.lat + "," + currentLocation.lng });
                console.log("findAddress result: ", result);
                if(result.code === 'OK'){
                    let country_code = result.data && result.data.content && result.data.content.length > 0 ? result.data.content[0].country_code : null;
                    if(country_code && contact && contact.country_agreement && country_code !== contact.country_agreement){
                        showMessage(true, t('CAN_NOT_FULFILL_ORDER_CURRENT_LOCATION'), order_type === 'DELIVERY' ? () => { history.push(paths.location) } : undefined)
                        checkLocation = false;
                    } else {
                        checkLocation = true;
                    }
                }
            }
        }catch(ex){
            console.log("onLookUpLocation ex: ", ex)
        }
        return checkLocation;
    }
    console.log('reOrder===', reOrder)
    console.log("showOrderCatalogues: ", showOrderCatalogues);
    return (
        <div>
            <OrderMainPageView
                delivery_address={getOrderCache(order_key.delivery_address)}
                pick_up_store={getOrderCache(order_key.pick_up_store) ? getOrderCache(order_key.pick_up_store) : pick_up_store}// fix when clear cache pick_up_store, fisrt loading not auto reload address
                showLoading={showLoading}
                showLoadingMyOrders={showLoadingMyOrders}
                showLoadingOffers={showLoadingOffers}
                showStores={showStores}
                message={message}
                confirm={confirm}
                showAddresses={showAddresses}
                addresses={addresses}
                showMenuItems={showMenuItems}
                promotions={promotions}
                my_orders={my_orders.content.length > 0 ? my_orders.content.slice(0, 5) : my_orders.content}
                currency={currency}
                handleShowRightContent={handleShowRightContent}
                onInitOrderDelivery={onInitOrderDelivery}
                onInitOrderPickUp={onInitOrderPickUp}
                onInitOrderDirectSale={onInitOrderDirectSale}
                showMessage={showMessage}
                onShowDetailOrder={onShowDetailOrder}
                onShowDetailOffer={onShowDetailPromotion}
                onShowAddCardForm={onShowAddCardForm}
                showConfirm={showConfirm}
                isShowOffer={isShowOffer}
                refreshMyOrders={loadMyOrders}
                onGoBackAfterSetCurrentAddress={onGoBackAfterSetCurrentAddress}
                onReorder={onReorder}
                reOrder={reOrder}
                onInitReOrderDelivery={onInitReOrderDelivery}
                onLookUpLocation={onLookUpLocation}
            />
            {showDetailOrder && <MyOrderDetailController
                open={showDetailOrder}
                onClose={() => setShowDetailOrder(false)}
                order={order}
                currency={currency} />}
            {showDetailPromotion && <PromotionDetail
                open={showDetailPromotion}
                offer={promotion}
                onClose={() => setShowDetailPromotion(false)} />}
            {showAddCardForm && <AddCard
                open={showAddCardForm}
                html_add_card_content={html_add_card_content}
                onClose={() => setShowAddCardForm(false)}

            />}
            {showSelectMerchant && <OrderMerchantsController
                showLoading={showLoading}
                open={showSelectMerchant}
                onClose={onCloseSelectMerchant}
                showMessage={showMessage}
            />}
            {showSelectStore && <OrderStoresController
                showLoading={showLoading}
                open={showSelectStore}
                reOrder={reOrder}
                onClose={() => onShowSelectStore(false)}
                showMessage={showMessage}
                onInitOrderPickUp={onInitOrderPickUp}
                supp_method={supp_method} />}
            {showSelectDirectSaleStore && <OrderDirectSaleStoresController
                showLoading={showLoading}
                open={showSelectDirectSaleStore}
                currentLocation={currentLocation}
                stores={stores}
                onClose={() => onShowSelectDirectSaleStore(false)}
                showMessage={showMessage}
                onInitOrderDirectSale={onInitOrderDirectSale}
                supp_method={supp_method} />}
            {showOrderCatalogues && <OrderCatalogues
                open={showOrderCatalogues}
                catalogActive={catalogActive}
                onClose={() => onShowOrderCatalogues(false)}
                onSelectCatalog={onSelectCatalog} />}
        </div>
    );
}

export default OrderMainPageController;